import { useCallback, useEffect, useState } from "react";
import axios from "axios";

// What admins set for /advertise on admin-cloudprint's Settings page (the backend's
// utils/ads.js). state is loading | ready | off | failed; ads is the page's content
// once ready.
const useAdInfo = () => {
  const [state, setState] = useState("loading");
  const [ads, setAds] = useState(null);

  const load = useCallback(() => {
    let live = true;
    setState("loading");
    axios
      .get("/api/ads/public")
      .then((res) => {
        if (!live) return;
        setAds(res.data.enabled ? res.data : null);
        setState(res.data.enabled ? "ready" : "off");
      })
      .catch(() => live && setState("failed"));
    return () => {
      live = false;
    };
  }, []);

  useEffect(load, [load]);

  return { state, ads, reload: load };
};

export default useAdInfo;
